'use client';

import { FaCloudArrowDown, FaCoins, FaFileCircleCheck, FaHandshake, FaPen, FaShieldHalved, FaShop, FaTableList } from "react-icons/fa6"
import Button from "./common/Button"
import CardStep from "./CardStep"

interface Props {
    actionButton?(): void
}

const LinePath: React.FC<Props> = ({ actionButton }: Props) => {

    const texts = [
        {
            title: "Compila il form qui sotto.",
            description: "Compila il form qui sotto per ricevere il link all'app Habacus.",
            icon: <FaTableList className='text-grayDark' size={'2rem'} />
        },
        {
            title: "Scarica l'app Habacus e registrati",
            description: "Scarica l'app Habacus e registrati per verificare il tuo status di studente.",
            icon: <FaCloudArrowDown className='text-grayDark' size={'2rem'} />
        },
        {
            title: "Accedi al servizio Uwelfare",
            description: "Accedi al servizio Uwelfare in app e inizia a versare 10€/mese nel fondo.",
            icon: <FaShieldHalved className='text-grayDark' size={'2rem'} />
        },
        {
            title: "Partecipa alle attività",
            description: "Partecipa alle attività per ottenere più bonus e aumentare il tuo co-finanziamento.",
            icon: <FaPen className='text-grayDark' size={'2rem'} />
        },
        {
            title: "Ricevi il tuo contributo extra",
            description: "Ricevi il tuo contributo extra: partecipa alle iniziative e scopri le opportunità per gli studenti.",
            icon: <FaShop className='text-grayDark' size={'2rem'} />
        }
    ]

    //come funziona
    return (
        <div className='mx-5 lg:mx-40 mb-20 lg:mb-40 '>
            <div className='text-center mb-10 lg:mb-20'>
                <h1 className='lg:mb-5'>Come aderire?</h1>
                <div>Più bonus ottieni, più cresce il tuo risparmio!</div>
            </div>

            {/* MOBILE */}
            <div className='lg:hidden '>
                <ul className='step-list'>
                    {texts.map((text, index) => (
                        <li className='step-item' key={"M-" + index}>
                            <div className="step-content pb-10 w-full">
                                <div className='bg-grayLight py-10 px-5 rounded-cornerMob'>
                                    <div className='flex justify-between flex-row-reverse lg:flex-col mb-3'>
                                        <div className='w-2/12 flex justify-end lg:justify-normal lg:mb-3'>
                                            {text.icon}
                                        </div>
                                        <h2 className='w-10/12 flex items-end'>{text.title}</h2>
                                    </div>
                                    <div>{text.description}</div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            {/* DESKTOP */}
            <div className='hidden lg:block'>
                <div>
                    {texts.map((text, index) => (
                        <div className='grid grid-cols-12' key={"D-" + index}>
                            <div className='col-span-5'>
                                {index % 2 === 0 ? null : (
                                    <CardStep
                                        icon={text.icon}
                                        title={text.title}
                                        text={text.description}
                                        className=""
                                    />
                                )}
                            </div>
                            <div className='col-span-2 flex justify-center'>
                                <div className={`relative h-full w-3 bg-blueLight${index === 0 ? ' rounded-t-cornerMob' : ''}`}>
                                    <div className='absolute left-1/2 transform -translate-x-1/2 top-1/4 -translate-y-1/2 w-5 h-5 bg-blueLight rounded-full '></div>
                                </div>
                            </div>
                            <div className='col-span-5'>
                                {index % 2 !== 0 ? null : (
                                    <CardStep
                                        icon={text.icon}
                                        title={text.title}
                                        text={text.description}
                                        className=""
                                    />
                                )}
                            </div>
                        </div>

                    ))}
                </div>
            </div>
            {actionButton ?
                <div className='flex justify-center mt-10 lg:mt-20'>
                    <Button
                        text="Inizia ora!"
                        onClick={actionButton}
                    />
                </div>
                : null}
        </div>
    );
}

export default LinePath;